<template>
  <div>
    <div class="d-left">
      <erp-tree @node-click="nodeClick" />
    </div>
    <div class="d-right">
      <div style="margin-top: 5px">
        <el-button @click="search">查询</el-button>
        <el-button @click="exportAmenityFee">导入公设费</el-button>
      </div>
      <el-descriptions :column="2" size="mini" border style="margin-top: 8px">
        <el-descriptions-item label="项目">
          <el-input
            v-model="form.houseName"
            size="mini"
            placeholder="输入房产或项目名称搜索"
          />
        </el-descriptions-item>
      </el-descriptions>
      <el-table
        max-height="750px"
        :data="listData"
        border
        style="margin-top: 8px"
        v-loading="loading"
      >
        <el-table-column prop="name" label="项目" />
        <el-table-column prop="year" label="年份" />
        <el-table-column prop="allotted_money_history" label="历史政府划拨" />
        <el-table-column prop="allotted_money_now" label="本年政府划拨" />
        <el-table-column prop="book_balance" label="账面余额（中修）" />
        <el-table-column prop="charge" label="本年可收（中修）" />
        <el-table-column prop="share_history" label="历年未分" />
        <el-table-column prop="share_now" label="本年预计未分" />
        <el-table-column prop="plan_charge" label="本年回收（预计）" />
        <el-table-column prop="balance" label="公设费期初余额" />
        <el-table-column prop="loss_target" label="亏损下降目标" />
        <el-table-column prop="create_at" label="创建时间" />
        <el-table-column prop="update_at" label="更新时间" />
        <el-table-column label="操作"> 
          <template slot-scope="data">
            <el-link :underline="false" @click="delAnenityFee(data.row.id)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="float: right; margin-top: 10px; margin-right: 20px"
        background
        :small="true"
        layout="prev, pager, next"
        :page-size="form.pageSize"
        :total="totalCount"
        :current-page.sync="form.page"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="导入文件"
      :visible.sync="dialogImportModel"
      width="60%"
      :before-close="handleImportClose"
      v-loading="loading"
    >
      <el-upload
        :action="url"
        :before-remove="beforeRemove"
        :on-success="handleAvatarSuccess"
        accept=".xls,.xlsx"
        :limit="1"
        :on-exceed="handleExceed"
        :file-list="fileList"
        :before-upload="beforeAvatarUpload"
      >
        <el-button size="small" type="primary"> 点击上传 </el-button>
        <div slot="tip">只能上传xls或xlsx文件，且不超过8M</div>
      </el-upload>
      <el-button size="mini" @click="importExcelData"> 导入 </el-button>
      <el-button size="mini" @click="downloadExcel"> 下载模板 </el-button>
      <el-table
        max-height="450px"
        :data="importData"
        border
        style="margin-top: 8px"
      >
        <el-table-column prop="name" label="项目" />
        <el-table-column prop="year" label="年份" />
        <el-table-column prop="allotted_money_history" label="历史政府划拨" />
        <el-table-column prop="allotted_money_now" label="本年政府划拨" />
        <el-table-column prop="book_balance" label="账面余额（中修）" />
        <el-table-column prop="charge" label="本年可收（中修）" />
        <el-table-column prop="share_history" label="历年未分" />
        <el-table-column prop="share_now" label="本年预计未分" />
        <el-table-column prop="plan_charge" label="本年回收（预计）" />
        <el-table-column prop="public_benefit" label="本年可结转公共收益分成（预计）" />
        <el-table-column prop="balance" label="公设费期初余额" />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import ErpTree from "@/components/Admin/Common/erp-tree";
import imgurl from "@/assets/js/imgurl.js";
export default {
  name: "AmenityFee",
  components: {
    ErpTree,
  },
  data() {
    return {
      form: {
        houseName: "",
        houseId: "",
        pid: "",
        pageSize:10,
        page:1
      },
      url: "",
      dialogImportModel: false,
      importData: [],
      fileList: [],
      listData:[],
      totalCount: 0,
      loading:false,
    };
  },
  watch: {
    "form.page"(n) {
      this.search();
    },
    "form.pageSize"(n) {
      this.search();
    },

  },
  mounted() {
    var login = window.localStorage.getItem("login");
    var token = window.localStorage.getItem("token");
    var oa_user_id = window.localStorage.getItem("oa_user_id");
    this.url =
      this.$myhttp.defaults.baseURL +
      "/admin/AmenityFee/importFile?" +
      "login_name=" +
      login +
      "&token=" +
      token +
      "&oa_user_id=" +
      oa_user_id;
  },
  methods: {
    nodeClick(data) {
      this.form.pid = data.tree[0].projectId;
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      this.form.houseName = tree_str;
      if (data.type === "room") {
        this.form.houseId = data.id;
      } else {
        this.form.houseId = "";
      }
    },
    exportAmenityFee() {
      this.dialogImportModel = true;
    },
    importExcelData() {
      this.loading = true;
      this.$myhttp
        .post(
          "admin/AmenityFee/importExcelData",
          { data: this.importData },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
            this.search();
            this.loading = false;
            this.handleImportClose();
          } else {
            this.$message.error(backdata.data.msg);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
          this.loading = false;
        });
    },
    handleImportClose() {
      this.dialogImportModel = false;
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.importData = [];
        })
        .catch(() => {});
    },
    handleAvatarSuccess(response, file, fileList) {
      if (response.code == 200) {
        this.importData = response.data.length > 0 ? response.data : [];
      } else {
        this.$message.error(response.msg);
      }
    },
    //超过一个文件
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    //限制大小
    beforeAvatarUpload(file) {
      const isLt7M = file.size / 1024 / 1024 < 8;
      if (!isLt7M) {
        this.$message.error("上传文件大小不能超过 8MB!");
      }
      return isLt7M;
    },
    search() {
      this.loading = true;
      this.$myhttp
        .post("admin/AmenityFee/index", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.loading = false;
            this.listData = backdata.data.data;
            this.totalCount = backdata.data.totalCount
          } else {
            this.$message.error(backdata.data.msg);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err);
        });
    },
    delAnenityFee(id) {
      this.loading = true;
      this.$myhttp
        .post("admin/AmenityFee/delete", {id}, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.loading = false;
            this.$message.success(backdata.data.msg);
            this.search()
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err);
        });
    },
    downloadExcel() {
      let url = imgurl + "/excel/公设费导入.xlsx";
      window.open("/office.html#/office?url=" + url, "_blank");
    },
  },
};
</script>
<style>
.d-left {
  border-right: 1px solid #eee;
  width: 250px;
  float: left;
}
.d-right {
  float: right;
  width: calc(100% - 265px);
}
</style>;



// WEBPACK FOOTER //
// src/components/Admin/AmenityFee/list.vue